import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import classnames from "classnames";
import SiniaCustomChart from "../../components/charts/sinia-custom-chart.component";
import * as WebDataRocksReact from "./webdatarocks.react";
import MapComponent from "./MapComponent";
import ListaTematica from "./lista-tematica";
import { DataService } from "../../services/data.service";
import { DICCIONARIO_REGIONES_CODIGO_A_TEXTO, DICCIONARIO_REGIONES } from "../../data/ubigeo.data";
import SVGIcon from "../../components/Utils/svgIcons";

import "./index.scss";
const styles = {
  mapDiv: {
    padding: 0,
    margin: 0,
    height: "500px",
    width: "100%"
  }
};


class VistaAnalisis extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      activeTab: "1",
      activeTabData: "3",
      indicadores: [],
      regiones: [],
      region_selected: [],
      indicador_selected: [],
      periodos: [],
      periodos_all: [],
      grid_header: {},
      grid_data: [],
      store_chart_data: { category: [], datos: [] },
      periodoValue: { min: 2, max: 10 }
    };
    this.lastColor = [];
    this.periodoInicio = React.createRef();
    this.periodoFin = React.createRef();
    this.pivot = React.createRef();
    this.chart = React.createRef();
    this.toggle = this.toggle.bind(this);
    this.selectLayerChange = this.selectLayerChange.bind(this);
    this.onSelectMap = this.onSelectMap.bind(this);
    this.onDeleteRegion = this.onDeleteRegion.bind(this);
    this.onDeleteIndicador = this.onDeleteIndicador.bind(this);
  }
  componentDidMount() {
    let me = this;
    me.mounted = true;
    me.processingData();
  }
  componentWillUnmount() {
    let me = this;
    me.mounted = false;
  }

  processingData() { 
    let me = this;
    DataService.getData(
      {
        query: "ANA07"
      },
      function (items) {
        if (items.ANA07 && items.ANA07.data.length) {
          let _indicadores = {};
          items.ANA07.data.map(function (item, i) {
            let id = item.id_tematica;
            _indicadores[id] = { value: item.id_tematica, label: item.tematica };
          });
          let _all_indicadores = [];
          Object.keys(_indicadores).map(function (item, i) {
            let _data = _indicadores[item];
            let _child = {};
            _child.id_serie = _data.value;
            _child.name = _data.label;
            let _child_serie = [];
            items.ANA07.data.map(function (child, i) {
              if (_data.value == child.id_tematica) {
                _child_serie.push({
                  id: child.id_serie,
                  label: child.indicador,
                  unidad: child.unidad,
                  sigla: child.sigla
                });
              }
            });
            _child.child = _child_serie;
            _all_indicadores.push(_child);
          });
          me.setState({
            indicadores: _all_indicadores
          });
        }
      }
    );
  }
  selectLayerChange(event) {
    let me = this;
    let found = false;
    if (event.checked) {
      let _data = me.state.indicador_selected || [];
      if (_data.length > 0) {
        _data.forEach(item => {
          if (item.id == event.id) {
            found = true;
          }
        });
      }
      if (!found) {
        _data.push({ id: event.id, nombre: event.label });
        me.getPeriodo(event.id);
      }
      me.setState({
        indicador_selected: _data
      });
    } else {
      const items = this.state.indicador_selected.filter(item => item.id !== event.id);
      me.setState({ indicador_selected: items });
    }

  }
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }
  toggleData(tab) {
    if (this.state.activeTabData !== tab) {
      this.setState({
        activeTabData: tab
      });
    }
  }

  getValores() {
    let me = this;
    let _regiones = me.state.region_selected;
    let _indicadores = me.state.indicador_selected;
    if (_regiones.length > 0 && _indicadores.length > 0) {
      let ubigeo_values = "";
      let indicador_values = "";
      _regiones.map(function (item) {
        ubigeo_values = (ubigeo_values === "" ? item.id + "0000" : ubigeo_values + "," + item.id + "0000");
      });
      _indicadores.map(function (item) {
        indicador_values = (indicador_values === "" ? item.id : indicador_values + "," + item.id);
      });

      let _grid_header = [];
      let __grid_data = [];
      DataService.getData(
        {
          query: "ANA09",
          marco: indicador_values,
          ubigeo: ubigeo_values + ",000000",
          periodo: this.periodoInicio.current.value,
          q1: this.periodoFin.current.value
        },
        function (items) {
          if (items.ANA09 && items.ANA09.data.length) {
            let _indicadores = {};
            let _unidad = {};
            let _unidad_chart = [];
            let _periodos = [];
            let _periodos_chart = [];

            let resultado_chart = {};
            let resultado_data = {};

            items.ANA09.data.forEach(item => {
              resultado_chart[item.ubigeo] = resultado_chart[item.ubigeo] || {};
              resultado_chart[item.ubigeo]['Ambito'] = item.ambito;
              resultado_chart[item.ubigeo]['Indicador'] = item.indicador;
              resultado_chart[item.ubigeo]['Unidad'] = item.unidad;
              resultado_chart[item.ubigeo].data = resultado_chart[item.ubigeo].data || [];
              resultado_chart[item.ubigeo].data.push({ id: item.periodo, name: +item.valor });


              resultado_data[item.ubigeo + "," + item.id_serie] = resultado_data[item.ubigeo + "," + item.id_serie] || {};
              resultado_data[item.ubigeo + "," + item.id_serie]['Ambito'] = item.ambito;
              resultado_data[item.ubigeo + "," + item.id_serie]['Indicador'] = item.indicador;
              resultado_data[item.ubigeo + "," + item.id_serie]['Unidad'] = item.unidad;
              resultado_data[item.ubigeo + "," + item.id_serie].data = resultado_data[item.ubigeo + "," + item.id_serie].data || [];
              resultado_data[item.ubigeo + "," + item.id_serie].data.push({ id: item.periodo, name: +item.valor });

              _periodos[item.periodo] = item.periodo;
              _indicadores[item.id_serie] = item.id_serie;
              _unidad[item.unidad] = item.unidad;
            });

            for (const key in resultado_data) {
              let item = resultado_data[key];
              let _content = {};
              _content['Ambito'] = item['Ambito'];
              _content['Indicador'] = item['Indicador'];
              _content['Unidad'] = item['Unidad'];
              let _new_value = {};
              if (item.data.length > 0) {
                item.data.forEach(item => {
                  _new_value[item.id] = item.name;
                });
              }
              for (const key in _periodos) {
                _content[key] = _new_value[key] || ' '
              }
              __grid_data.push(_content);
            }
            _periodos.forEach(item => {
              _grid_header.push({
                'uniqueName': item,
                'aggregation': 'sum'
              });
              _periodos_chart.push(item);
            });
            for (const key in _unidad) {
              let item = _unidad[key];
              _unidad_chart.push(item);
            }
            /**
             * Process CHART
             */
            let __data_chart = [];
            for (const key in resultado_data) {
              let item = resultado_data[key];
              let _content = [];
              let _new_value = {};
              if (item.data.length > 0) {
                item.data.forEach(item => {
                  _new_value[item.id] = item.name;
                });
              }
              for (const key in _periodos) {
                _content.push(_new_value[key] || 0);
              }
              __data_chart.push({ name: item['Ambito'], data: _content, color: me.getRandColor(false, 5), borderColor: me.getRandColor(true, 5), borderWidth: 1 });
            }
            me.setChart(__data_chart, _periodos_chart, _unidad_chart.length > 0 ? _unidad_chart.join(",") : "");

            me.setState({
              grid_data: __grid_data,
              grid_header: {
                "rows": [{
                  "uniqueName": "Ambito",
                  "sort": "unsorted"
                },
                {
                  "uniqueName": "Indicador",
                  "sort": "unsorted"
                },
                {
                  "uniqueName": "Unidad",
                  "sort": "unsorted"
                }
                ],
                "columns": [{
                  "uniqueName": "Measures",
                  "sort": "unsorted"
                }],
                "measures": _grid_header
              }
            });
          } else {
            me.setState({
              grid_data: [],
              grid_header: {
                "rows": [{
                  "uniqueName": "Ambito",
                  "sort": "unsorted"
                },
                {
                  "uniqueName": "Indicador",
                  "sort": "unsorted"
                },
                {
                  "uniqueName": "Unidad",
                  "sort": "unsorted"
                }
                ],
                "columns": [{
                  "uniqueName": "Measures",
                  "sort": "unsorted"
                }],
                "measures": []
              }
            });
          }
        }
      );
    } else {
      alert("Seleccione al menos una región y un indicador");
    }
  }
  getRandColor(same, darkness) {
    //6 levels of brightness from 0 to 5, 0 being the darkest
    var rgb = [];
    if (same && this.lastColor) {
      rgb = this.lastColor;
    } else {
      rgb = [Math.random() * 256, Math.random() * 256, Math.random() * 256];
    }
    var mix = [darkness * 51, darkness * 51, darkness * 51]; //51 => 255/5
    var mixedrgb = [rgb[0] + mix[0], rgb[1] + mix[1], rgb[2] + mix[2]].map(function (x) {
      return Math.round(x / 2.0)
    })
    this.lastColor = rgb;
    return "rgb(" + mixedrgb.join(",") + ")";
  }

  setChart(data, category, unidad) {
    this.chart.current.actualizarDatos(data, category);
    this.chart.current.actualizarOpciones({
      yAxis: {
        title: {
          text: unidad
        }
      }
    });
  }

  getPeriodo(serie) {
    let me = this;
    DataService.getData(
      {
        query: "ANA08",
        serie: serie
      },
      function (items) {
        let _periodo = {};
        _periodo = me.state.periodos_all;
        if (items.ANA08 && items.ANA08.data.length) {
          items.ANA08.data.forEach(item => {
            _periodo[item.periodo] = item.periodo;
          });
          me.setState({
            periodos: items.ANA08.data,
            periodos_all: _periodo
          });
        }
      }
    );
  }
  onSelectMap(codigo) {
    let me = this;
    let found = false;
    let _data = me.state.region_selected || [];
    if (_data.length > 0) {
      _data.forEach(item => {
        if (item.id == codigo) {
          found = true;
        }
      });
    }
    if (!found) {
      _data.push({ id: codigo, nombre: me.getRegionName(codigo) });
    }
    me.setState({
      region_selected: _data
    });
  }

  getRegionName(id) {
    return DICCIONARIO_REGIONES_CODIGO_A_TEXTO[id];
  }
  onDeleteRegion(itemId) {
    let me = this;
    const items = this.state.region_selected.filter(item => item.id !== itemId);
    if (items.length == 0) {
      me.setState({ region_selected: items, grid_data: [], store_chart_data: { category: [], datos: [] } });
    } else {
      me.setState({ region_selected: items });
    }
  };
  onDeleteIndicador(itemId) {
    let me = this;
    const items = me.state.indicador_selected.filter(item => item.id !== itemId);
    if (items.length == 0) {
      me.setState({ indicador_selected: items, grid_data: [], store_chart_data: { category: [], datos: [] } });
    } else {
      me.setState({ indicador_selected: items });
    }
  };

  onDeleteAllRegion() {
    let me = this;
    me.setState({ region_selected: [] });
  }

  onAddAllRegion() {
    let me = this;
    me.setState({ region_selected: DICCIONARIO_REGIONES });
  }

  render() {
    const {
      indicadores,
      region_selected,
      indicador_selected,
      periodos_all,
      grid_data,
      grid_header,
      periodoValue
    } = this.state;
    return (
      <div className="content">
        <Row className="no-gutters">
          <Col>
            <Card className="header-toolbar-menu">
              <CardBody className="text-center">
                <span className="text-white  header-toolbar-menu-text-size">
                  Análisis de indicadores ambientales
                </span>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} xl={4}>
            <Card>
              <CardHeader>
                <CardTitle>
                  <div className="h5 text-primary">
                    <i className="icon-regiones" /> Información geográfica
                  </div>
                </CardTitle>
              </CardHeader>
              <CardBody>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: this.state.activeTab === "1"
                      })}
                      onClick={() => {
                        this.toggle("1");
                      }}
                    >
                      1. Mapa Nacional
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: this.state.activeTab === "2"
                      })}
                      onClick={() => {
                        this.toggle("2");
                      }}
                    >
                      2. Indicadores por temática
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="1">
                    <Row>
                      <Col sm={12}>
                        <div id="viewDiv" style={styles.mapDiv}>
                          <MapComponent onSelectMap={this.onSelectMap} />
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="2">
                    <Row>
                      <Col sm={12}>
                        <ListaTematica
                          onChange={this.selectLayerChange}
                          items={indicadores}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
          <Col xs={12} sm={12} md={12} xl={8}>
            <Card>
              <Row className="no-gutters">
                <Col>
                  <CardHeader>
                    <CardTitle>
                      <Row className="no-gutters">
                        <Col xs={12} sm={12} md={12} xl={8}>
                          <div className="h5 text-primary">
                            <i className="icon-mapa" /> Regiones seleccionadas({region_selected.length})
                          </div>
                        </Col>
                        <Col xs={6} sm={6} md={6} xl={2}>
                          <span className="pointer font-italic text-right" title="Agregar todos">
                            <a href="javascript:" onClick={() => this.onAddAllRegion()}>Todos</a>
                          </span>
                        </Col>
                        <Col xs={6} sm={6} md={6} xl={2}>
                          <span className="pointer  text-right font-italic" title="Limpiar todos">
                            <a href="javascript:" onClick={() => this.onDeleteAllRegion()}>Limpiar</a>
                          </span>
                        </Col>
                      </Row>
                    </CardTitle>
                  </CardHeader>
                  <CardBody>
                    <div className="content-selected-option">
                      <ul className="list-group">
                        {region_selected.length > 0 ? (
                          <div>
                            {region_selected.map((item, key) => {
                              return (
                                <li
                                  key={item.id}
                                  id={item.id}
                                  className="list-group-item">
                                  <i className={`icon-region_${item.id} text-primary mr-2`}></i>
                                  <label className="ml-2" htmlFor={item.id}>{item.nombre}</label>
                                  <span onClick={() => this.onDeleteRegion(item.id)} className="analisis-info-icon pointer" title="Quitar">
                                    <SVGIcon id={'icon-remove'} />
                                  </span>
                                </li>
                              )
                            })}
                          </div>
                        ) : (
                            <div className="text-center">
                              <span className="h6  text-primary">
                                {" "}
                                Seleccione al menos una región del mapa nacional
                      </span>
                            </div>
                          )}
                      </ul>
                    </div>
                  </CardBody>
                </Col>
                <Col>
                  <CardHeader>
                    <CardTitle>
                      <div className="h5 text-primary">
                        <i className="icon-indicadores" /> Indicadores seleccionados({indicador_selected.length})
                      </div>
                    </CardTitle>
                  </CardHeader>
                  <CardBody>
                    <div className="content-selected-option">
                      <ul className="list-group">
                        {indicador_selected.length > 0 ? (
                          <div>
                            {indicador_selected.map((item, key) => {
                              return (
                                <li
                                  key={item.id}
                                  id={item.id}
                                  className="list-group-item">
                                  <label className="ml-2" htmlFor={item.id * item.id}>{item.nombre}</label>
                                  <span onClick={() => this.onDeleteIndicador(item.id)} className="analisis-info-icon pointer " title="Quitar">
                                    <SVGIcon id={'icon-remove'} />
                                  </span>
                                </li>
                              )
                            })}
                          </div>
                        ) : (
                            <div className="text-center">
                              <span className="h6  text-primary">
                                {" "}
                                Seleccione al menos un indicador de (Indicadores por temática)
                      </span>
                            </div>
                          )}
                      </ul>
                    </div>
                  </CardBody>
                </Col>
              </Row>
              <Row className="no-gutters">
                <Col>
                  <CardBody>
                    <Row className="no-gutters">
                      <Col xs={6} sm={12} md={12} xl={2}>
                        <label>3. </label>
                        <label>Periodo inicio :</label>
                        <select
                          className="form-control select-periodo"
                          ref={this.periodoInicio}
                          defaultValue={Object.keys(periodos_all)[0] != null ? Object.keys(periodos_all)[0] : ''}
                        >
                          {Object.keys(periodos_all).length > 0 ? (
                            <>
                              {Object.entries(periodos_all).map((t, k) => <option key={k} value={t[0]}>{t[1]}</option>)} </>
                          ) : (
                              <>
                              </>
                            )}
                        </select>
                      </Col>
                      <Col xs={6} sm={12} md={12} xl={2}>
                        <label >Periodo fin : </label>
                        <select
                          className="form-control select-periodo"
                          ref={this.periodoFin}
                        >
                          {periodos_all.length > 0 ? (
                            <>
                              {Object.entries(periodos_all).map((t, k) => <option selected={t[0]} key={k} value={t[0]}>{t[1]}</option>)} </>
                          ) : (
                              <>
                              </>
                            )}
                        </select>
                      </Col>
                      <Col xs={6} sm={12} md={12} xl={2}>
                        <div className="mt-3">
                          <button type="button" onClick={() => this.getValores()} className="btn btn-outline-primary btn-sm">
                            Consultar
                        </button>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={12} md={12} xl={12}>
                  <CardBody>
                    <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: this.state.activeTabData === "3"
                          })}
                          onClick={() => {
                            this.toggleData("3");
                          }}
                        >
                          Datos
                    </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: this.state.activeTabData === "4"
                          })}
                          onClick={() => {
                            this.toggleData("4");
                          }}
                        >
                          Gráficos
                    </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTabData}>
                      <TabPane tabId="3">
                        <Row>
                          <Col sm={12}>
                            {grid_data.length > 0 ? (
                              <WebDataRocksReact.Pivot ref={this.pivot} toolbar={true} datasource={grid_data} slice={grid_header} />
                            ) : (
                                <div className="webdatarocks-grid-none">

                                </div>
                              )}
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="4">
                        <Row>
                          <Col sm={12}>
                            <div className="webdatarocks-grid-none">
                              <SiniaCustomChart
                                exportable={true}
                                chartType={"line"}
                                titleTpl={"Tendencia"}
                                yAxeTitle="Eje Y"
                                seriesLabel="Eje X"
                                xAxeTitle="Periodo"
                                source={""}
                                multiSeries={true}
                                ref={this.chart}
                              />
                            </div>
                          </Col>
                        </Row>
                      </TabPane>
                    </TabContent>
                  </CardBody>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default VistaAnalisis;
